export default {
  name: 'validations.attributes.humanReadableId',
  ivrPhoneNumber: 'validations.attributes.ivrPhoneNumber',
  supportPhoneNumber: 'validations.attributes.supportPhoneNumber',
  driverConnectPhoneNumber: 'validations.attributes.driverConnectPhoneNumber',
  iosMinimumSupportedProductVersion: 'validations.semverInvalid',
  androidMinimumSupportedProductVersion: 'validations.semverInvalid',
};
